import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { fileDownloadActions } from '@wdx/shared/infrastructure/file-io';
import {
    InterpolationDisplayService,
    InterpolationFragment,
    InterpolationFragmentType,
} from '@wdx/shared/utils';
import * as rootReducer from '../../../state/_setup/reducers';

@Component({
    selector: 'clmi-interpolation-display',
    templateUrl: './interpolation-display.component.html',
    standalone: false,
})
export class InterpolationDisplayComponent implements OnInit {
    readonly NOTIFICATION_FRAGMENT_TYPE = InterpolationFragmentType;
    private interpolationDisplayService = inject(InterpolationDisplayService);

    fragments: Array<InterpolationFragment>;

    @Input() entityId!: string;
    @Input() text!: string;

    @Output() linkSelected = new EventEmitter<void>();

    private store$ = inject(Store<rootReducer.State>);

    ngOnInit(): void {
        // TODO: remove all code supporting the old format: #name:id:type#
        // and just support new format: [type|id|name]
        // when API just returns new format
        if (/#[^:#]+:[^:#]+:[^:#]+#/.test(this.text)) {
            this.fragments =
                this.interpolationDisplayService.oldParseInterpolation(
                    this.text,
                    this.entityId,
                );
        } else {
            this.fragments =
                this.interpolationDisplayService.parseInterpolation(
                    this.text,
                    this.entityId,
                );
        }
    }

    onDownload(fragment: InterpolationFragment) {
        this.store$.dispatch(
            fileDownloadActions.getFileDownload({
                fileIndex: fragment.fileIndex,
                fileName: fragment.value,
            }),
        );
    }

    onLinkSelected(): void {
        this.linkSelected.emit();
    }
}
